// Wellbeing bands from the zencera design system (1–5 scale):
// below 3.0 Attention · 3.0–3.69 Watch · 3.7+ Healthy. A band always carries
// its word as well as its colour.
// The label is looked up from i18n strings: `band.${key}`.
export type Band = { key: 'crit' | 'warn' | 'good'; color: string };

export function bandOf(score: number): Band {
  if (score < 3) return { key: 'crit', color: 'var(--crit)' };
  if (score < 3.7) return { key: 'warn', color: 'var(--score-watch)' };
  return { key: 'good', color: 'var(--score-good)' };
}

// Mean of a { "1": n, "2": n, … } mood histogram. Only ever called on an
// aggregate the server has already cleared (status === 'ok').
export function meanMood(counts: Record<string, number>): number | null {
  let sum = 0;
  let n = 0;
  for (const [k, v] of Object.entries(counts)) {
    const m = Number(k);
    if (!Number.isFinite(m) || !v) continue;
    sum += m * v;
    n += v;
  }
  return n ? sum / n : null;
}

// ISO-8601 week number and year, for the topbar's "Week 41 · 2026" label.
export function isoWeek(d = new Date()): { week: number; year: number } {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = t.getUTCDay() || 7;
  t.setUTCDate(t.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((t.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  return { week, year: t.getUTCFullYear() };
}
